<template id="grup-edit">
  <div class="maxw">
    <h2>Editar Grup de Tallers</h2>
    <b-form v-on:submit.prevent="updateGrup">
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Grup:" label-for="input-nombre">
            <b-form-input
                id="input-nombre"
                v-model="grup.nombre"
                required
                autofocus
                placeholder="Enter name"
              ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Web:" label-for="input-url">
            <b-form-input
                id="input-url"
                type="url"
                v-model="grup.url"
              ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Actiu:" label-for="input-rep">
            <b-form-checkbox v-model="grup.isActive" name="check-button" switch>
              Activar / Desactivar Centro <b>(Checked: {{ grup.isActive }})</b>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <h3>Centres</h3>
      </b-row>
      <b-table striped hover :items="grup.centros" :fields="Grupfields"></b-table>
      <b-row>
        <b-col cols="6"></b-col>
        <b-col class="col text-right">
          <b-button class="mr-2" variant="outline-success" type="submit">Gravar</b-button>
          <b-button class="mr-2" variant="outline-primary"><router-link :to="{ name: 'Grups'}">Cancel</router-link></b-button>
        </b-col>
      </b-row>
      <b-form-input :hidden="true" type="text" v-model="grup.identifier"></b-form-input>
    </b-form>
  </div>
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'

export default {
  props: {
    grup: {
      identifier: null,
      nombre: null,
      centros: [],
      isActive: null,
      isDelete: null,
      url: null
    }
  },
  data () {
    return {
      Grupfields: [
        {
          key: 'nombre',
          label: 'Nombre',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'dirección',
          label: 'Dirección',
          sortable: false
        },
        {
          key: 'poblacion',
          label: 'Población',
          sortable: false
        },
        {
          key: 'provincia',
          label: 'Provincia',
          sortable: false
        },
        {
          key: 'isActive',
          label: 'Está Activo',
          formatter: (value, key, item) => {
            return value ? 'Sí' : 'No'
          },
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true
        }
      ]
    }
  },
  methods: {
    updateGrup () {
      (async () => {
        await DataAccess.putData('/api/grupos', this.grup.identifier, {
          identifier: this.grup.identifier,
          nombre: this.grup.nombre,
          isActive: this.grup.isActive,
          Url: this.grup.url
        })
          .then(response => {
            this.$router.push({ name: 'Grups' })
          })
          .catch(error => {
            console.log('ERROR: ', error)
          })
      })()
    }
  }
}
</script>

<style scoped>
  .maxw {
    width: 80%;
    margin: 40px auto;
  }
</style>
